<template>
  <tr
    :class="item.status === 'To answer' ? 'active' : ''"
    style="cursor: pointer"
    :style="
      selected.includes(item.i_msg)
        ? 'background: -webkit-linear-gradient(left, rgba(62, 76, 143, 0.35) 0%, rgb(218 217 232) 20%, rgba(222, 222, 222, 0.11) 80%, rgb(198 200 221) 100%);'
        : ''
    "
  >
    <td class="text-center" style="width: 12px">
      <v-btn icon small @click="toggleCheckbox(item)">
        <v-icon :color="selected.includes(item.i_msg) ? 'primary' : ''">
          {{
            selected.includes(item.i_msg)
              ? `mdi-checkbox-marked-outline`
              : `mdi-checkbox-blank-outline`
          }}</v-icon
        >
      </v-btn>
    </td>
    <td class="text-center" style="width: 10px" @click="select_user(item)">
      <v-icon
        class="px-0"
        :color="
          $store.state.online_users.includes(item.guid.toString())
            ? 'green'
            : '#e0e0e0'
        "
        size="20"
        >mdi-record</v-icon
      >
    </td>
    <td class="text-center" style="width: 10px">
      <v-tooltip color="black" top>
        <template v-slot:activator="{ on }">
          <v-row>
            <v-col align="center">
              <v-btn
                elevation="0"
                fab
                x-small
                v-on="on"
                @click="change_priority(item)"
              >
                <v-icon color="warning" v-if="item.priority">mdi-star</v-icon>
                <strong v-else>-</strong>
              </v-btn>
            </v-col>
          </v-row>
        </template>
        <span v-if="item.priority">High</span>
        <span v-else>Unspecified</span>
      </v-tooltip>
    </td>
    <td class="px-1 text-center" @click="select_user(item)">
      <v-row align="center" no-gutters>
        <v-col sm="12" cols="12" class="text-truncate">
          <span
            class="d-inline-block text-truncate mt-1"
            style="max-width: 100px"
            >{{ item.contact }}</span
          >
        </v-col>
      </v-row>
    </td>
    <td class="text-center px-1" @click="select_user(item)">
      <v-row align="center" no-gutters>
        <v-col sm="12">
          {{ item.sent_at_value }}
        </v-col>
      </v-row>
    </td>
    <td style="width: 15%" @click="select_user(item)">
      <v-row align="center" no-gutters>
        <v-col sm="12" class="text-truncate">
          <span
            class="d-inline-block text-truncate mt-1 font-weight-regular"
            style="
              max-width: 250px;
              max-height: 25px;
              vertical-align: -webkit-baseline-middle;
            "
            v-html="highLightMessage(item)"
          ></span>
        </v-col>
      </v-row>
    </td>
    <td
      class="text-center mx-0 px-0"
      style="width: 11%"
      @click="select_user(item)"
    >
      <v-menu offset-y transition="scale-transition" dense>
        <template v-slot:activator="{ on }">
          <v-btn
            :color="item.statusObj.color"
            class="text-capitalize caption font-weight-medium"
            outlined
            small
            width="88%"
            height="25px"
            v-on="on"
          >
            <b
              >{{ getStatus(item.statusObj.value) }}
              {{
                item.statusObj.value === "Answered"
                  ? item.sender_type === "bot"
                    ? "B"
                    : "H"
                  : ""
              }}</b
            >
            <v-icon small>mdi-menu-down</v-icon>
          </v-btn>
        </template>
        <v-list nav dense>
          <v-list-item
            v-for="(n, idx) in status"
            :key="idx"
            link
            v-show="n.value !== item.statusObj.value"
            @click="change_status(item, n)"
          >
            <v-list-item-title class="text-center">
              {{ getStatus(n.value) }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </td>
    <td class="text-center" style="width: 15%" @click="select_user(item)">
      <v-row align="center" no-gutters>
        <v-col sm="12" class="text-truncate">
          <span
            class="d-inline-block mt-1 text-truncate font-weight-regular"
            style="
              max-width: 250px;
              max-height: 25px;
              vertical-align: -webkit-baseline-middle;
            "
          >
            {{ parseConversationSubjects(item.conversation_subject) }}
          </span>
        </v-col>
      </v-row>
    </td>
    <td
      class="text-center px-1"
      @click="agents && agents.length ? select_user(item) : showAgentInputRe()"
    >
      <!-- <span>{{ item.status !== "To answer" ? "-" : item.waiting_value }}</span> -->
      <v-menu
        offset-y
        transition="scale-transition"
        dense
        :disabled="agents && agents.length ? false : true"
      >
        <template v-slot:activator="{ on }">
          <v-btn
            class="text-capitalize caption font-weight-medium"
            small
            outlined
            width="88%"
            height="25px"
            v-on="on"
            color="grey"
          >
            <b>{{ item.agent }}</b>
            <v-icon small>mdi-menu-down</v-icon>
          </v-btn>
        </template>
        <v-list width="150" nav dense>
          <v-list-item
            v-show="item.agent"
            link
            @click="change_agent(item, 'remove')"
          >
            <v-list-item-title class="text-center">
              <v-icon small class="mb-1" color="error">mdi-close</v-icon> Remove
              agent
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            v-for="(n, idx) in agents"
            :key="idx"
            link
            @click="change_agent(item, n)"
          >
            <v-list-item-title class="text-center">
              {{ n }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </td>
    <td
      class="text-center px-0"
      style="width: 7%"
      @click="getProduct(item.add_to_cart)"
      v-show="$store.state.ui.msgTrackingState.cart"
    >
      <div v-if="item.add_to_cart && item.add_to_cart.count">
        <div>
          <v-icon color="rgb(17, 65, 206)" size="18">
            mdi-cart-arrow-down
          </v-icon>
          <v-badge
            botton
            bordered
            offset-x="5"
            offset-y="15"
            color="#008000"
            :content="item.add_to_cart.count"
          />
        </div>
      </div>
      <div v-else>
        <v-icon size="18">mdi-cart-arrow-down</v-icon>
      </div>
    </td>
    <td
      class="text-center px-0"
      style="width: 7%"
      @click="purchse_products(item.pruchase)"
      v-show="$store.state.ui.msgTrackingState.purchase"
    >
      <div v-if="item.pruchase && item.pruchase.count">
        <div>
          <v-icon color="rgb(17, 65, 206)" size="18">
            add mdi-shopping-search
          </v-icon>
          <v-badge
            botton
            bordered
            offset-x="5"
            offset-y="15"
            color="#008000"
            :content="1"
          />
        </div>
      </div>
      <div v-else>
        <v-icon size="18">add mdi-shopping-search</v-icon>
      </div>
    </td>
    <td class="pr-0 px-1">
      <v-list dense color="transparent" class="mx-0 px-0 text-center">
        <v-list-item class="mx-0 px-0 pr-12">
          <v-list-item-content @click="select_user(item)">
            <v-list-item-title class="mx-0 px-0">
              <v-list-item-subtitle class="black--text">
                <span v-if="!item.AdminNote"> - </span>
                <span
                  class="d-inline-block text-truncate mt-1"
                  style="max-width: 150px"
                >
                  {{ item.AdminNote }}
                </span>
              </v-list-item-subtitle>
            </v-list-item-title>
          </v-list-item-content>

          <v-tooltip top color="black">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="note_change(item)"
                v-bind="attrs"
                v-on="on"
                absolute
                right
                icon
              >
                <v-icon small color="#1141ce">mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("messanger.dash.update") }}</span>
          </v-tooltip>
        </v-list-item>
      </v-list>
    </td>
  </tr>
</template>

<script>
import utils from "@/utils";

export default {
  name: "Tbody",
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    selected: {
      type: Array,
      default: () => [],
    },
    receiver_ids: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    selected_product: [],
    form: "",
    obj: {},
    old_note: "",
  }),
  computed: {
    status() {
      return this.$store.state.messages.status;
    },
    email_status() {
      return this.$store.state.messages.email_status;
    },
    store_config() {
      const data = this.$store.state.store_config.store;
      return data;
    },
    agents() {
      return this.$store.state.admin.admin_details.agents;
    },
  },
  mounted: function () {},
  methods: {
    showAgentInputRe() {
      this.$store.dispatch("setSnackbar", {
        showing: true,
        right: true,
        text: `Please fill the agents first (go to 'Options' -> 'AGENTS')`,
        color: "info",
        timeout: 6000,
      });
    },
    highLightMessage(item) {
      let text =
        typeof item.last_message === "object"
          ? item.last_message.key
            ? this.$t(`messanger.dash.msg_types.${item.last_message.key}`)
            : item.last_message.message || item.last_message.content
          : this.translate(item.last_message) || item.last_message;
      text = utils.convertMardownToHTML(text);
      return text;
    },
    getConvSubject(name) {
      return this.$t(`messanger.conversation_subjects.${name}`);
    },
    parseConversationSubjects(array) {
      if (!array || array.length === 0) {
        return "-";
      }
      // format the array split by ','
      // translate using i18n
      // return the string formatted
      let formatted = [];
      for (let i = 0; i < array.length; ++i) {
        formatted.push(this.getConvSubject(array[i]));
      }
      return formatted.join(", ");
    },
    getStatus(name) {
      return this.$t(`messanger.dash.status.${name}`);
    },
    getEmailStatus(name) {
      return this.$t(`messanger.dash.email_status.${name}`);
    },
    toggleCheckbox(item) {
      console.log(item);
      if (!this.selected.includes(item.i_msg)) {
        this.selected.push(item.i_msg);
        this.receiver_ids.push(item.receiver);
      } else {
        const idx = this.selected.indexOf(item.i_msg);
        this.selected.splice(idx, 1);
        this.receiver_ids.splice(idx, 1);
      }
    },
    change_priority(item) {
      this.from = "priority";
      this.obj = {
        msg_id: item.i_msg,
        id: item.id_c,
        priority: { check: true, value: !item.priority },
      };
      this.save();
    },
    async select_user(value) {
      try {
        console.log(value);
        this.$store.state.chat_user = value;
        this.$store.state.user_conversation_id = value.conversation_id
          ? value.conversation_id.toString()
          : value.id_c.toString();
        this.$store.dispatch("setCloader", { showing: true });
        this.$store.state.user_selected = value.receiver_id;
        await this.$store.dispatch("FETCH_USER_MESSAGES", value.receiver_id);
        this.$store.dispatch("setCloader", { showing: false });
        this.$store.state.show.dash = false;
        this.$store.state.show.chat = true;
        this.$store.state.notification.notif =
          this.$store.state.notification.notif -
          this.$store.state.notification.users[value.guid];
      } catch (e) {
        this.$store.dispatch("setCloader", { showing: false });
        this.$store.state.show.dash = true;
        this.$store.state.show.chat = false;
        this.$store.dispatch("setSnackbar", {
          showing: true,
          center: true,
          text: "Error in puling the conversation data",
          color: "error",
          timeout: 2000,
        });
      }
    },
    change_status(item, st) {
      this.from = "status";
      this.obj = {
        msg_id: item.i_msg,
        id: item.id_c,
        status: st.value,
        status_obj: st,
      };
      this.save();
      if (
        st.value === "By email" &&
        item.EmailStatusObj.value !== "To answer"
      ) {
        let temp = {
          msg_id: item.i_msg,
          id: item.id_c,
          e_status: "To answer",
          status_obj: { color: "red darken-1", value: "To answer" },
        };
        this.$store.dispatch("UPDATE_MSG", temp).then((r) => {
          this.$socket.emit("UpdateAction", {
            data: temp,
            from: "e_status",
          });
        });
      }
    },
    change_EmailStatus(item, st) {
      this.from = "e_status";
      this.obj = {
        msg_id: item.i_msg,
        id: item.id_c,
        e_status: st.value,
        status_obj: st,
      };
      this.save();
    },
    note_change(item) {
      this.$store
        .dispatch("confirmer/ask", {
          note_dialog: true,
          note: item.AdminNote,
        })
        .then((confirmation) => {
          if (confirmation) {
            this.from = "note";
            this.old_note = item.AdminNote;
            this.obj = {
              msg_id: item.i_msg,
              id: item.id_c,
              text: confirmation.text,
              note: true,
            };
            if (this.old_note !== this.obj.text) this.save();
          }
        });
    },
    change_agent(item, agent) {
      this.from = "agent";
      this.obj = {
        msg_id: item.i_msg,
        id: item.id_c,
        guid: item.guid,
        agent,
      };
      this.save();
    },
    agentAssignEmitSender() {
      const agent_obj = {
        type: "agent_assign",
        agent: this.obj.agent,
        user: this.obj.guid,
        conversation_id: this.obj.msg_id,
        sender_type: "admin",
        context: "chat",
        message: `Agent assined ${this.obj.agent}`,
      };
      this.$socket.emit("ChatUser", agent_obj, (data) => {
        if (typeof data === "string") {
          console.error(data);
        } else {
          console.log(agent_obj);
          console.log(data);
        }
      });
    },
    save() {
      /**
       * Properties available on `this.item` are not always the same.
       * I have to use other properties, that are also not always available.
       *
       * Keep in sync with `conversation_data` in `Conversation_options.vue` component.
       *
       * @type {{
       *  storeId: string;
       *  id: string;
       *  conversation_id: number;
       *  guid: string;
       *  context: string;
       *  content: string;
       *  sent_at: string;
       *  status: string;
       * }}
       */
      const conversation_data = {
        storeId: this.item.store_id,
        id: this.item.id ?? this.item.receiver_id,
        conversation_id: Number(this.item.id_c),
        guid: this.item.guid,
        content: this.item.content ?? this.item.last_message,
        sent_at: this.item.sent_at,
        context: this.item.context,
        status: this.obj.status ?? this.item.status,
      };
      this.obj.conversation_data = conversation_data;

      this.$store.dispatch("setCloader", { showing: true });
      if (this.from === "priority") {
        this.$store.dispatch("UPDATE_MSG", this.obj).then((r) => {
          this.$store.dispatch("setSnackbar", {
            showing: true,
            right: true,
            text: `Priority change to ${
              !this.obj.priority.value ? "Unspecified" : "High"
            }`,
            color: "success",
            timeout: 2000,
          });
          this.$socket.emit("UpdateAction", {
            data: this.obj,
            from: this.from,
          });
          this.$store.dispatch("setCloader", { showing: false });
        });
      } else if (this.from === "status") {
        this.$store.dispatch("UPDATE_MSG", this.obj).then((r) => {
          this.$store.dispatch("setSnackbar", {
            showing: true,
            right: true,
            text: `Message status change to ${this.obj.status_obj.value}`,
            color: this.obj.status_obj.color,
            timeout: 2000,
          });
          this.$socket.emit("UpdateAction", {
            data: this.obj,
            from: this.from,
          });
          this.$store.dispatch("setCloader", { showing: false });
        });
      } else if (this.from === "note") {
        this.$store.dispatch("UPDATE_MSG", this.obj).then((r) => {
          this.$store.dispatch("setSnackbar", {
            showing: true,
            right: true,
            text: `Message note updated`,
            color: "success",
            timeout: 2000,
          });
          this.$socket.emit("UpdateAction", {
            data: this.obj,
            from: this.from,
          });
          this.$store.dispatch("setCloader", { showing: false });
        });
      } else if (this.from === "e_status") {
        //add the update dispatch
        this.$store.dispatch("UPDATE_MSG", this.obj).then((r) => {
          this.$store.dispatch("setSnackbar", {
            showing: true,
            right: true,
            text: `Message status change to ${this.obj.status_obj.value}`,
            color: this.obj.status_obj.color,
            timeout: 2000,
          });
          this.$socket.emit("UpdateAction", {
            data: this.obj,
            from: this.from,
          });
          this.$store.dispatch("setCloader", { showing: false });
        });
      } else if (this.from === "agent") {
        //add the update dispatch
        this.$store.dispatch("UPDATE_MSG", this.obj).then((r) => {
          if (this.obj.agent === "remove") {
            this.obj.agent = null;
          } else {
            this.agentAssignEmitSender();
          }
          this.$store.dispatch("setSnackbar", {
            showing: true,
            right: true,
            color: "success",
            text: `Agent change to ${this.obj.agent}`,
            timeout: 2000,
          });
          this.$socket.emit("UpdateAction", {
            data: this.obj,
            from: this.from,
          });
        });
      }
      this.$store.dispatch("setCloader", { showing: false });
    },
    getProduct(p) {
      this.$store.dispatch("setAddToCard", {
        showing: true,
        selected_product: p.selected_product,
      });
    },
    purchse_products(p) {
      this.$store.dispatch("setPurchaseProducts", {
        showing: true,
        selected_product: p.selected_product,
      });
    },
    translate(steps) {
      const keys = steps.split(".");
      let result = this.store_config.i18n[this.$i18n.locale];
      for (let i = 0; i < keys.length; i++) {
        const element = keys[i];
        if (result[element]) result = result[element];
        else return null;
      }
      return result;
    },
  },
};
</script>
<style scoped>
.active {
  transition: transform 0.15s;
  font-weight: 600;
  color: #000000;
  background-color: #e8e7e769 !important;
}
.selected {
  background: -webkit-linear-gradient(
    left,
    rgb(30 18 18 / 37%) 0%,
    rgb(222 222 222) 20%,
    rgba(222, 222, 222, 0) 80%,
    rgba(222, 222, 222, 1) 100%
  );
}
</style>
